module.exports = __webpack_public_path__ + "img/popularize04-3.2dc1ad04.png";